/* global swal, _, Beamer angular */
import './style.less';
import { get } from 'lodash';

export default function(UserClass, ProfileClass, ResolveClass, $state, $transitions, $timeout, $scope, $q) {
  'ngInject';
  const vm = this;

  vm.bulb = 'https://assets.prolaera.com/bulb.png';
  vm.largeLogo = 'https://assets.prolaera.com/whiteProlaeraTextlogo.png';
  vm.smallLogo = 'https://assets.prolaera.com/WhiteProlaeraLogo.png';
  vm.user = UserClass;
  vm.userProfile = ProfileClass;
  vm.profile_uid = UserClass.profile_uid;
  vm.admin = UserClass.admin;
  vm.author = UserClass.author;
  vm.team_leader = UserClass.team_leader;
  vm.event_coordinator = UserClass.event_coordinator && !UserClass.admin;
  vm.state = $state;

  const qArr = [
    ProfileClass.profileComplete,
  ];

  $q.all(qArr)
    .then(([profileComplete]) => {
      vm.disableButtons = get(profileComplete, 'company.preferences.read_only.user.support', false);
    });

  const companyInfo = ProfileClass.profileComplete.company;

  // TODO: Finish getting started
  // if (
  //   ProfileClass.profileComplete &&
  //   ProfileClass.profileComplete.profile &&
  //   ProfileClass.profileComplete.profile.gettingStarted === false
  // )
  vm.gettingStarted = false;
  // else vm.gettingStarted = true;

  if (companyInfo && companyInfo.company_id) {
    // Disables features
    vm.jccs = companyInfo.company_id === 49 && !vm.admin;
    vm.sch = companyInfo.company_id === 55 && !vm.admin && !vm.team_leader;
    vm.dfc = companyInfo.company_id === 66 && !vm.admin && !vm.team_leader;
    vm.bonadio = companyInfo.company_id === 69;
    vm.firmMember = companyInfo.company_id !== 1;
    vm.alignDisable = companyInfo.company_id === 42;
    vm.bundles = get(companyInfo, 'preferences.bundles.active', false);
    vm.forms = companyInfo.formsActive && (companyInfo.hasPublishedForms || vm.admin || false);
  }

  vm.applicationSettings = feature => {
    return ResolveClass.applicationSettings(feature);
  };

  if (companyInfo && companyInfo.logo && companyInfo.logo.lg) vm.largeLogo = companyInfo.logo.lg;
  if (companyInfo && companyInfo.logo && companyInfo.logo.sm) vm.smallLogo = companyInfo.logo.sm;

  if (companyInfo !== undefined && companyInfo.skin !== undefined) {
    angular.element('body').removeClass('skin-prolaera');
    angular.element('body').addClass(companyInfo.skin);
  }

  // Start Beamer
  if (vm.admin || vm.author) $timeout(() => Beamer.init(), 0);

  const createClassStateObj = activeCheck => {
    return propName => {
      return { [propName]: activeCheck };
    };
  };

  vm.adminActive = createClassStateObj(
    ($state.current.name.includes('app.admin') || $state.current.name.includes('app.eventManager')) &&
      !$state.current.name.includes('app.admin.settings')
  );

  vm.coursesActive = createClassStateObj(
    $state.current.name.includes('app.internalCourses') ||
      $state.current.name.includes('app.courses') ||
      $state.current.name.includes('app.events') ||
      $state.current.name.includes('app.cpeCatalog')
  );

  vm.eventsManagerActive = createClassStateObj(
    $state.current.name.includes('app.admin') && !$state.current.name.includes('app.admin.settings')
  );

  vm.myAccountActive = createClassStateObj(
    $state.current.name.includes('app.users.certificates.hours') ||
      $state.current.name.includes('app.users.settings.profile') ||
      $state.current.name.includes('app.users.settings.licenses')
  );

  vm.myDashboardActive = createClassStateObj(
    $state.current.name.includes('app.users.dashboard') ||
      $state.current.name.includes('app.users.learning') ||
      $state.current.name.includes('app.users.compliance') ||
      ($state.current.name.includes('app.users.certificates') &&
        !$state.current.name.includes('app.users.certificates.hours')) ||
      $state.current.name.includes('app.users.report')
  );
}



// WEBPACK FOOTER //
// ./src/app/components/sideNav/controller.js